import { connect } from 'react-redux';
import _ from 'lodash';

import PresentationComponent from '../../../components/dashboards/tabcomponents/TemplateDrawer';
import {
  createTemplate,
  deleteTemplate,
  resetTemplate,
  toggleEventTemplate,
  updateTemplate,
} from '../../../actions/dashboards/templates';
import {
  getEventIdUsingTemplate,
  getEvents,
  getEventsGroupColumn,
  getFilteredTemplatesByType,
} from '../../../reducers/analyticsApp';
import { EVENT_TEMPLATE_TYPE } from '../../../constants/dashboards';
import { setErrorMessage } from '../../../actions/application';
import { validation } from '../../../utils/dashboards';

const composeTemplateDescription = ({ events, groupBy }) =>
  events
    ? events
        .filter((event) => !!event.name)
        .map((event) => {
          const eventName = `${event.name} by ${groupBy}`;
          const splitBy = _.isNil(event.splitColumn) ? '' : ` split by ${event.splitColumn}`;
          const aggregationType = `(${event.aggregationType}`;
          const aggregationField = _.isNil(event.aggregationColumn)
            ? ')'
            : `[${event.aggregationColumn}])`;
          return eventName + splitBy + aggregationType + aggregationField;
        })
        .join(' + ')
    : '';

const mapStateToProps = (state) => ({
  templates: getFilteredTemplatesByType(state, EVENT_TEMPLATE_TYPE),
  idUsingTemplate: getEventIdUsingTemplate(state),
  descriptionParams: {
    events: getEvents(state),
    groupBy: getEventsGroupColumn(state),
  },
});

const mapDispatchToProps = {
  onReset: () => resetTemplate(EVENT_TEMPLATE_TYPE),
  createTemplate: (templateName, templateDescription) =>
    createTemplate(templateName, templateDescription, EVENT_TEMPLATE_TYPE),
  updateTemplate: (templateName, templateDescription) =>
    updateTemplate(templateName, templateDescription, EVENT_TEMPLATE_TYPE),
  onToggle: toggleEventTemplate,
  setErrorMessage: (message) => setErrorMessage(message),
  onDelete: (id) => deleteTemplate(id),
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  composeDescription: (setDescription) => {
    setDescription(composeTemplateDescription(stateProps.descriptionParams));
  },
  onCreate: (templateName, templateDescription) =>
    validation(
      dispatchProps.setErrorMessage,
      templateName,
      templateDescription,
      dispatchProps.createTemplate
    ),
  onUpdate: (templateName, templateDescription) =>
    validation(
      dispatchProps.setErrorMessage,
      templateName,
      templateDescription,
      dispatchProps.updateTemplate
    ),
});

const EventTemplateDrawer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(PresentationComponent);

export default EventTemplateDrawer;
